import React, { useState, useEffect } from "react";
import Card from "../../../components/Card/Card";
import { getCardById } from "../../../api/api";
import { useParams } from "react-router-dom";
import loader from "../../../assets/images/loader.gif";
import "./CardView.css";

export function CardView() {
  const { id } = useParams();
  const [verificationStatus, setVerificationStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(true);
  const [message, setMessage] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [email, setEmail] = useState([]);
  const [phone, setPhone] = useState([]);
  const [fname, setFname] = useState([]);
  const [lname, setLname] = useState([]);
  const [org, setOrg] = useState([]);
  const [title, setTitle] = useState([]);

  const getCardData = () => {
    getCardById(id)
      .then((res) => {
        if (res.data.data.contactDetails != undefined) {
          res.data.data.contactDetails[0]
            ? setVerificationStatus(true)
            : setVerificationStatus(false);

          res.data.data.contactDetails.forEach((element, index, array) => {
            switch (element.socialContactType) {
              case "email":
                if (element.isPrimary) {
                  setEmail(element);
                }
                break;
              case "phone":
                if (element.isPrimary) {
                  setPhone(element);
                }
                break;
              case "firstName":
                if (element.isPrimary) {
                  setFname(element);
                }
                break;
              case "lastName":
                if (element.isPrimary) {
                  setLname(element);
                }
                break;
              case "organization":
                if (element.isPrimary) {
                  setOrg(element);
                }
                break;
              case "title":
                if (element.isPrimary) {
                  setTitle(element);
                }
                break;
              default:
                break;
            }
          });
          setProfilePic(res.data.data.cardProfileThumbnail);
          setMessage("");
        }

        if (res.data.data.length == 0) {
          setActive(false);
          setMessage(res.data.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getCardData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="align-center">
          <img src={loader} alt="loading..." className="loader" />
        </div>
      ) : (
        <Card
          loading={loading}
          success={verificationStatus}
          profilePic={profilePic}
          email={email}
          phone={phone}
          fname={fname}
          lname={lname}
          org={org}
          title={title}
          id={id}
          active={active}
          message={message}
        />
      )}
    </>
  );
}
